import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NatureGarantie } from "src/app/parametrage/core/model/garanties/nature-garantie";
import { NatureGarantieService } from "src/app/parametrage/core/service/nature-garantie.service";

@Component({
  selector: "app-add-nature-garantie",
  templateUrl: "./add-nature-garantie.component.html",
  styleUrls: ["./add-nature-garantie.component.scss"],
})
export class AddNatureGarantieComponent implements OnInit {
  natureGarantie: NatureGarantie;
  form: FormGroup;
  pressButton: Boolean = false;
  title: string;
  loading = false;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private shared: NatureGarantieService
  ) {}

  ngOnInit() {
    this.form = this.createForm(this.natureGarantie);
  }

  createForm(data: NatureGarantie) {
    if (data) {
      return this.fb.group({
        id: [data ? data.id : ""],
        codeNatureGarantie: [
          data ? data.codeNatureGarantie : "",
          Validators.compose([Validators.required]),
        ],
        libelleNatureGarantie: [data ? data.libelleNatureGarantie : ""],
        active: [data ? data.active : null],
        estEligible: [data ? data.estEligible : null],
      });
    } else {
      return this.fb.group({
        id: [data ? data.id : ""],
        codeNatureGarantie: ["", Validators.compose([Validators.required])],
        libelleNatureGarantie: [""],
        active: [true, Validators.compose([Validators.required])],
        estEligible: [false],
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    if (!this.natureGarantie) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  createData() {
    this.shared.add(this.form.value).subscribe(
      (data) => {
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      }
    );
  }

  updateData() {
    this.shared.update(this.natureGarantie.id, this.form.value).subscribe(
      (data) => {
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      }
    );
  }
}
